export const getLinks = (apiKey: string, after?: string) => `
query GetLinks {
  getLinks(apiKey: "${apiKey}"${after ? `, after: "${after}"` : ''}) {
      items {
        id
        opened
        protected
        qrCode {
          type
        }
        redirectTo
        url
      }
      nextToken
      totalCount
  }
}`;
